"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var SyntheticEventClass = /*#__PURE__*/function () {
  function SyntheticEventClass(value, evt) {
    (0, _classCallCheck2.default)(this, SyntheticEventClass);
    var target = {
      value: value
    };
    this.target = target;
    this.currentTarget = target;
    this.source = evt;
  }

  (0, _createClass2.default)(SyntheticEventClass, [{
    key: "preventDefault",
    value: function preventDefault() {
      if (this.source) {
        this.source.preventDefault();
      }
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      if (this.source) {
        this.source.stopPropagation();
      }
    }
  }]);
  return SyntheticEventClass;
}();

function SyntheticEvent(value, evt) {
  return new SyntheticEventClass(value, evt);
}

SyntheticEvent.constructor = SyntheticEventClass;
var _default = SyntheticEvent;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/core/SyntheticEvent.js
// module id = 32
// module chunks = 209 210 211 212